import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=490636bc&scoped=true&lang=pug&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490636bc",
  null
  
)

export default component.exports